<template>
	<div>
		
		<div class="r-title">
			<img src="../../assets/imgs/news/news-title-bg.png" class="r-title-bg">
			<span style="z-index: 1;position: relative;">Reservations</span>
		</div>
		
		<div>
			
			<div style="display: flex;flex-direction: column;">
				<div style="display: flex;flex-direction: column;margin-top: 1rem;" v-for="(item, index) in data" :key="index">
					<div style="display: flex;align-items: center;">
						<div style="flex: 1;display: flex;align-items: center;">
							<div class="avatar" :style="{backgroundImage:'url('+item.user.avatar+')'}" style="min-width: 2.5rem;height: 2.5rem;margin-right: 1rem;"></div>
							<div style="display: flex;flex-direction: column;">
								<div style="font-weight: bold;font-size: 1rem;">{{item.user.username}}</div>
								<div style="display: flex;flex-wrap: wrap;font-size: 0.5rem;color: #999">
									{{item.createdAt|format}}
								</div>
							</div>
						</div>
						<div style="display: flex;align-items: center;">
							<div style="font-weight: bold;" :style="{color:item.status == 2?'#000':'#09DBC7'}">{{item.status==2?'processed':'Pending'}}</div>
						</div>
					</div>
					<div style="font-size: 1rem;color: #666;margin: 1rem 0;">
						{{item.content}}
					</div>
					
					<div style="background-color: #f8f8f8;padding: 1rem;border-radius: 0.5rem;" v-if="item.expert">
						<div style="display: flex;align-items: center;">
							<div style="flex: 1;display: flex;align-items: center;">
								<div class="avatar" :style="{backgroundImage:'url('+item.expert.avatar+')'}" style="min-width: 2.5rem;height: 2.5rem;margin-right: 1rem;"></div>
								<div style="display: flex;flex-direction: column;">
									<div style="font-weight: bold;font-size: 1rem;">{{item.expert.realName}}</div>
								</div>
							</div>
							<div style="display: flex;flex-wrap: wrap;font-size: 0.5rem;color: #999">
								{{item.updatedAt|format}}
							</div>
						</div>
						<div style="font-size: 1rem;color: #666;margin: 1rem 0;">
							{{item.expertAnswer}}
						</div>
					</div>
				</div>
				<div v-show="data.length==0&&!loading" class="nodata-box">
					<img src="../../assets/imgs/nodata.svg" class="nodata-img">
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	
		import axios from 'axios'
		import {baseUrl} from '../../assets/js/public.js'
		export default {
			data() {
				return {
					type:0,
					data:[],
					colorlist:['#01A587', '#8D66F8', '#ED532B', '#D8BE50', '#52A5F7'],
					loading:true
				}
			},
			components: {
			},
			methods: {
				getdata(){
					this.loading = true
					this.request({
						method: 'get',
						url: '/gci/appointment/expert/list',
					}).then(res => {
						this.data = res.data.items
						this.loading = false
					}).catch(error => {
						console.error(error.response)
					})
				}
			},
			mounted() {
				this.type = this.$route.query.type
				this.getdata()
			}
		}
</script>

<style lang="scss" scoped>
	.r-title{
		height: 3rem;
		font-size: 1.5rem;
		font-weight: bold;
		position: relative;
		.r-title-bg{
			width: 13rem;position: absolute;left: -0.5rem;top: -2rem
		}
	}
	
	.avatar{
		background-position: center;background-repeat: no-repeat;background-size: cover;border-radius: 50%;
	}
</style>